'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var TagIcon = function (props) {
    var computedProps = tslib_es6.__assign({ fill: 'currentColor', width: 20, height: 20 }, props);
    return (React__default['default'].createElement("svg", tslib_es6.__assign({}, computedProps, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
        React__default['default'].createElement("path", { fillRule: "evenodd", d: "M17.317 2.83882L18.4516 10.2139L9.92391 18.7416L1.41421 10.2319L9.94191 1.70419L17.317 2.83882ZM19.517 10.5627L18.1938 1.96195L9.59312 0.638763L0.707106 9.52477L0 10.2319L0.707106 10.939L9.21681 19.4487L9.92391 20.1558L10.631 19.4487L19.517 10.5627ZM14.1788 7.87107C13.6558 8.39402 12.808 8.39402 12.285 7.87107C11.7621 7.34812 11.7621 6.50026 12.285 5.97731C12.808 5.45437 13.6558 5.45437 14.1788 5.97731C14.7017 6.50026 14.7017 7.34812 14.1788 7.87107ZM14.8859 8.57818C13.9724 9.49165 12.4914 9.49165 11.5779 8.57818C10.6644 7.66471 10.6644 6.18368 11.5779 5.27021C12.4914 4.35674 13.9724 4.35674 14.8859 5.27021C15.7993 6.18368 15.7993 7.66471 14.8859 8.57818Z" })));
};

exports.default = TagIcon;
//# sourceMappingURL=index.js.map
